export const AI_CHAT_FEED_EMPTY_MESSAGE =
  "Clockwise AI Scheduler is a conversational calendar experience that makes scheduling a breeze.";
